import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  // 🆕 Accepter un rôle unique OU un tableau de rôles
  requiredRole?: 'company_director' | 'site_manager' | 'project_supervisor' 
              | ('company_director' | 'site_manager' | 'project_supervisor')[];
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole,
  redirectTo = '/auth'
}) => {
  const { user, loading } = useAuth();

  // Redirection immédiate si pas d'user et pas en loading
  if (!loading && !user) {
    return <Navigate to={redirectTo} replace />;
  }

  // Redirection si mauvais rôle (après chargement)
  if (!loading && requiredRole && user?.role) {
    const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!allowedRoles.includes(user.role as any)) {
      const defaultRoute = 
        user.role === 'company_director' || user.role === 'project_supervisor' 
          ? '/dashboard' : '/site';
      return <Navigate to={defaultRoute} replace />;
    }
  }

  // Passer les enfants immédiatement - AppLayout gère son propre état de chargement
  return <>{children}</>;
};